import React from 'react';
import { BarChart3, ChevronDown, ChevronUp, HelpCircle, Loader2, Shield, Trophy, Users, Zap } from 'lucide-react';

const GuideTab = ({ ctx }) => {
  const { guide, guideOpen, setGuideOpen } = ctx;

  return (
<div data-testid="guide-tab">
  <h1 className="text-xl font-bold mb-1" style={{ color: '#1A1209' }}>How-To Guide & FAQ</h1>
  <p className="text-xs mb-6" style={{ color: '#999' }}>
    Select a topic below to learn more about managing your organisation&apos;s HiBFF account.
  </p>

  {/* Section cards grid */}
  {!guideOpen._activeSection && guide?.sections && (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="guide-sections-grid">
      {guide.sections.map((section, si) => {
        const iconMap = { rocket: Zap, users: Users, chart: BarChart3, trophy: Trophy, shield: Shield, help: HelpCircle };
        const Icon = iconMap[section.icon] || HelpCircle;
        const colors = ['#F5831F', '#2563EB', '#10B981', '#8B5CF6', '#EF4444', '#F59E0B'];
        const sectionColor = colors[si % colors.length];
        return (
          <button
            key={si}
            onClick={() => setGuideOpen({ _activeSection: si })}
            className="bg-white rounded-2xl p-6 text-left transition-all hover:shadow-lg hover:-translate-y-0.5 group"
            style={{ border: '2px solid #E8E8E8' }}
            data-testid={`guide-section-${si}`}
          >
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110"
              style={{ backgroundColor: `${sectionColor}12` }}>
              <Icon size={22} style={{ color: sectionColor }} />
            </div>
            <h3 className="text-base font-bold mb-1" style={{ color: '#1A1209' }}>{section.title}</h3>
            <p className="text-xs" style={{ color: '#999' }}>{section.items.length} question{section.items.length !== 1 ? 's' : ''}</p>
          </button>
        );
      })}
    </div>
  )}

  {/* Expanded section view */}
  {guideOpen._activeSection !== undefined && guideOpen._activeSection !== null && guide?.sections && (() => {
    const si = guideOpen._activeSection;
    const section = guide.sections[si];
    if (!section) return null;
    const iconMap = { rocket: Zap, users: Users, chart: BarChart3, trophy: Trophy, shield: Shield, help: HelpCircle };
    const Icon = iconMap[section.icon] || HelpCircle;
    const colors = ['#F5831F', '#2563EB', '#10B981', '#8B5CF6', '#EF4444', '#F59E0B'];
    const sectionColor = colors[si % colors.length];
    return (
      <div data-testid="guide-section-detail">
        {/* Back button + section header */}
        <button
          onClick={() => setGuideOpen({})}
          className="flex items-center gap-2 mb-5 text-sm font-semibold hover:opacity-70 transition-opacity"
          style={{ color: sectionColor }}
          data-testid="guide-back-btn"
        >
          <ChevronDown size={14} className="rotate-90" /> Back to all topics
        </button>
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${sectionColor}12` }}>
            <Icon size={20} style={{ color: sectionColor }} />
          </div>
          <h2 className="text-lg font-bold" style={{ color: '#1A1209' }}>{section.title}</h2>
        </div>

        {/* Q&A list */}
        <div className="space-y-2">
          {section.items.map((item, qi) => {
            const qKey = `${si}-${qi}`;
            const isOpen = guideOpen[qKey];
            return (
              <div key={qi} className="bg-white rounded-xl overflow-hidden transition-shadow"
                style={{ border: isOpen ? `2px solid ${sectionColor}40` : '1px solid #E8E8E8' }}
                data-testid={`guide-q-${si}-${qi}`}>
                <button
                  onClick={() => setGuideOpen(p => ({ ...p, [qKey]: !p[qKey] }))}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="text-sm font-semibold pr-4" style={{ color: '#1A1209' }}>{item.q}</span>
                  {isOpen ? <ChevronUp size={16} style={{ color: sectionColor }} /> : <ChevronDown size={16} style={{ color: '#CCC' }} />}
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 border-t" style={{ borderColor: '#F3F4F6' }}>
                    <p className="text-sm leading-relaxed pt-4" style={{ color: '#333', lineHeight: '1.7' }}>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  })()}

  {!guide && (
    <div className="bg-white rounded-xl p-8 text-center" style={{ border: '1px solid #E8E8E8' }}>
      <Loader2 size={24} className="animate-spin mx-auto mb-3" style={{ color: '#DDD' }} />
      <p className="text-sm" style={{ color: '#999' }}>Loading guide...</p>
    </div>
  )}
</div>
  );
};

export default GuideTab;
